<template>
    <v-row>        
        <!-- <ActionDropdown 
            :items="actions"
            context="Prolists"
        />           -->
        <ImportButton                 
            :items="importOptions"
            :label="$t('lang_PUBLISHING_TRACKING_BUTTON_CAPTION_IMPORT_STATEMENTS')"
            context="FileImport"
            cols="3"
        /> 
        <v-spacer></v-spacer>    
        <v-row align="end" class="pr-3">
            <v-col align="end"> 
                <BaseIcon 
                    @click="validation(saveDataTable)"
                    icon="save"
                    tooltipText="lang_GENERAL_BUTTON_SAVE"
                />    
            </v-col> 
        </v-row>
    </v-row>
</template>

<script>
import ActionDropdown from '@/components/_actions/ActionDropdown'
import ImportButton from '@/components/_buttons/ImportButton'
import BaseIcon from '@/components/_buttons/BaseIcon.vue'

export default {
    name: "ProlistsPanelTopSlot",    
    components: {
        ActionDropdown,
        ImportButton,
        BaseIcon
    },
    props: {
        validation: Function
    },
    computed: {
        actions() {
            return [
                {text: this.$t('lang_GENERIC_CAPTION_DELETE'), value: 'delete'}
            ]
        },        
        importOptions() {
            return [
                {text: this.$t("lang_PUBLISHING_TRACKING_BUTTON_OPTION_GEMA_NA"), value: "gemaNA"}
            ]
        }
    },
    methods: {
        saveDataTable() {
            this.$store.dispatch("saveProlists")
        }
    }
}
</script>